import lodashGet from 'lodash/get';
import {get} from '../utils/ajaxHelper';
import {getExpectedEncodedUriLength} from '../utils/loggerHelper';

const lengthLimit = 4000;
const headersLimit = 5;
const errorStackLimit = 150;

/* eslint-disable complexity */
function log(data) {
    const url = '/pdp/logger';
    const logDataKeys = Object.keys(data);

    // Enforce length limit to prevent HTTP GET length errors that occur in some browsers/servers.
    if (getExpectedEncodedUriLength(url, data) > lengthLimit) {
        for (let i = 0; i < logDataKeys.length; i++) {
            if (typeof data[logDataKeys[i]].slice === 'function') {
                data[logDataKeys[i]] = data[logDataKeys[i]].slice(0, lengthLimit);
            }

            // some browsers add headers and stack trace to network error logs and that causes HTTP GET length errors
            if (data[logDataKeys[i]] instanceof Error && data[logDataKeys[i]].networkError) {
                const stack = lodashGet(data[logDataKeys[i]], 'networkError.stack');
                const headersMap = lodashGet(
                    data[logDataKeys[i]],
                    'networkError.response.headers.map'
                );
                if (stack && typeof stack.slice === 'function') {
                    data[logDataKeys[i]].networkError.stack = stack.slice(0, errorStackLimit);
                }
                // send limited number of headers to log
                if (headersMap && typeof headersMap === 'object') {
                    data[logDataKeys[i]].networkError.response.headers.map = Object.keys(headersMap)
                        .filter((_, index) => index < headersLimit)
                        .reduce((result, key) => {
                            result[key] = headersMap[key];
                            return result;
                        }, {});
                }
            }
        }
    }

    // Ensure `requestMarker` id
    if (global.window) {
        if (!data.originRequestMarker) {
            data.originRequestMarker =
                window.debugLog && window.debugLog.requestMarker
                    ? window.debugLog.requestMarker
                    : 'unknown';
        }

        if (!data.variant) {
            data.variant = window.debugLog ? window.debugLog.variant : 'unknown';
        }

        if (!data.site) {
            data.site = window.debugLog ? window.debugLog.site : 'unknown';
        }

        // Ensure `fssessionurl` is included in the logs, if present.
        if (window.analyticsdatalayer && window.analyticsdatalayer.fssessionurl) {
            data.fssessionurl = window.analyticsdatalayer.fssessionurl;
        }

        if (window.ha && window.ha.browserName) {
            data.browserName = window.ha.browserName;
        }

        // Until we are production ready, log all the Logged events to the debugLog for easy parusal.
        window.log ? window.log(`[LOGGER] ${JSON.stringify(data)}`) : null; // eslint-disable-line
    }

    return get(url, data).catch(() => {});
}

export default log;
export {log};
